/**
 * PreviewCookie — Cookie consent banner
 */
import { useState } from 'react';

interface PreviewCookieProps {
  data: {
    title?: string;
    text?: string;
    policyLink?: string;
    acceptNecessary?: string;
    acceptReject?: string;
    openSettings?: string;
    acceptAll?: string;
  };
  settings: {
    [key: string]: any;
  };
}

export function PreviewCookie({ data, settings }: PreviewCookieProps) {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="preview-cookie">
      <h4>{data.title}</h4>
      <p>
        {data.text} <a href={data.policyLink}>Mehr erfahren</a>
      </p>
      <div className="preview-cookie__actions">
        <button
          className="preview-cookie__necessary"
          onClick={() => setVisible(false)}
        >
          {data.acceptNecessary}
        </button>
        <button
          className="preview-cookie__reject"
          onClick={() => setVisible(false)}
        >
          {data.acceptReject || "Ablehnen"}
        </button>
        <button
          className="preview-cookie__settings"
          onClick={() => setVisible(false)}
        >
          {data.openSettings || "Einstellungen"}
        </button>
        <button
          className="preview-cookie__all"
          onClick={() => setVisible(false)}
        >
          {data.acceptAll}
        </button>
      </div>
    </div>
  );
}
